export enum SUBMIT_TO_MARKET_PATHS {
  Root = '',
  Draft = 'draft',
  SelectStructures = 'select-structures',
  SelectMarkets = 'select-markets',
  UploadAttachments = 'upload-attachments',
  AddQuoteRequestData = 'add-quote-request-data',
  DraftDashboard = 'draft-dashboard',
  EmailTemplates = 'email-templates',
  SendEmails = 'send-emails',
}

/**
 * The index of a route in the array is the mapping
 */
export const DRAFT_STEPPING_MAPPING: SUBMIT_TO_MARKET_PATHS[] = [
  SUBMIT_TO_MARKET_PATHS.SelectStructures,
  SUBMIT_TO_MARKET_PATHS.SelectMarkets,
  SUBMIT_TO_MARKET_PATHS.UploadAttachments,
  SUBMIT_TO_MARKET_PATHS.AddQuoteRequestData,
  SUBMIT_TO_MARKET_PATHS.DraftDashboard,
  SUBMIT_TO_MARKET_PATHS.EmailTemplates,
  SUBMIT_TO_MARKET_PATHS.SendEmails,
]
